import Loading from "./loading";

export default {
  Loading
};



// WEBPACK FOOTER //
// ./src/directives/index.js